import { FiGithub, FiLinkedin, FiArrowDown } from 'react-icons/fi';
import headshot from '../headshot/Profile_Picture_Mac_20260408.jpg';
import resumePdf from '../Resume/MacStrommerResume_20260418.pdf';
import './Hero.css';

const Hero = () => {
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section className="hero" id="hero" aria-label="Introduction">
      <div className="hero__inner">
        <div className="hero__text">
          <p className="hero__greeting">Hello, I'm</p>
          <h1 className="hero__name">
            McKendree<br />
            <span className="hero__name-accent">Strommer</span>
          </h1>
          <p className="hero__title">
            Software Engineer
            <span className="hero__title-sep" aria-hidden="true"> · </span>
            AI &amp; Full-Stack
          </p>
          <p className="hero__bio">
            I build enterprise systems that move millions of dollars worth of lab specimens
            through the healthcare supply chain — and I make sure they don't break. Currently
            Software Engineer II at{' '}
            <a
              href="https://www.biotouchglobal.com"
              target="_blank"
              rel="noreferrer"
              className="hero__bio-link"
            >
              BioTouch
            </a>
            .
          </p>

          <div className="hero__actions">
            <button className="btn btn-primary" onClick={() => scrollTo('#projects')}>
              View Projects
            </button>
            <a href={resumePdf} download="Mac_Strommer_Resume.pdf" className="btn btn-outline">
              Download Resume
            </a>
          </div>

          <div className="hero__socials">
            <a
              href="https://github.com/Windowmac"
              target="_blank"
              rel="noreferrer"
              className="hero__social-link"
              aria-label="GitHub profile"
            >
              <FiGithub aria-hidden="true" />
            </a>
            <a
              href="https://www.linkedin.com/in/mckendree-strommer-957070122"
              target="_blank"
              rel="noreferrer"
              className="hero__social-link"
              aria-label="LinkedIn profile"
            >
              <FiLinkedin aria-hidden="true" />
            </a>
          </div>
        </div>

        <div className="hero__photo-wrap" aria-hidden="true">
          <div className="hero__photo-ring">
            <img
              src={headshot}
              alt="Mac Strommer"
              className="hero__photo"
              loading="eager"
            />
          </div>
          <div className="hero__photo-glow" />
        </div>
      </div>

      <button
        className="hero__scroll-cue"
        onClick={() => scrollTo('#about')}
        aria-label="Scroll down"
      >
        <FiArrowDown aria-hidden="true" />
      </button>
    </section>
  );
};

export default Hero;
